<!-- eslint-disable no-unused-labels -->
<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Lista" subTitle="Indicações">
      <d-button class="float-right" @click="exportCSV()">Exportar CSV</d-button>
    </page-header>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div
            class="card-header border-bottom d-flex justify-content-around custom-header"
          >
            <div class="col-md-3 col-12 d-flex align-items-center">
              <h6 class="m-md-0 m-2">Indicações Ativas</h6>
            </div>
            <div class="col-md-9 col-12 p-0">
              <form class="main w-100">
                <d-form-row>
                  <d-col
                    sm="12"
                    lg="3"
                    md="6"
                    class="d-flex mb-2 justify-content-start"
                  >
                    <autocomplete
                      ref="autocomplete"
                      placeholder="Região"
                      :items.sync="regions"
                      item-show="name"
                      :on-input="onInput"
                      :on-select="setRegion"
                      :showIconClear="true"
                    />
                  </d-col>
                  <d-col sm="12" md="6" lg="3" class="mb-2">
                    <select-state 
                      :model.sync="pagination.state" 
                      :onChange="onChangeState" 
                    />
                  </d-col>
                  <d-col
                    sm="12"
                    lg="3"
                    md="6"
                    class="d-flex mb-2 w-100 justify-content-start"
                  >
                    <datepicker-interval
                      :dateTo.sync="pagination.date_to"
                      :dateFrom.sync="pagination.date_from"
                    />
                  </d-col>
                  <d-col sm="12" md="6" lg="3">
                    <input-search
                      :model.sync="pagination.search"
                      id="input_region_list_search"
                    />
                  </d-col>
                </d-form-row>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <lead-table :leads.sync="leads.list" />
            </div>
            <pagination
              :total-items="leads.total_items"
              :pagination.sync="pagination"
              :eventName="'update:pagination_lead_list'"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { downloadCsvFile } from '_utils';
import PageHeader from '_shared/PageHeader.vue';
import LeadService from '_services/rest/modules/lead';
import Pagination from '_shared/Pagination.vue';
import InputSearch from '_shared/InputSearch.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import DatepickerInterval from '_shared/DatepickerInterval.vue';
import SelectState from '_shared/SelectState.vue';
import paginationStorageMixin from '_common/mixins/paginationStorageMixin';
import LeadTable from '../components/LeadListTable.vue';

export default {
  name: 'lead-list',
  components: {
    Autocomplete,
    PageHeader,
    Pagination,
    LeadTable,
    InputSearch,
    DatepickerInterval,
    SelectState,
  },
  mixins: [paginationStorageMixin],
  data() {
    return {
      pagination: {
        date_from: null,
        date_to: null,
        search: '',
        state: null,
        region: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    leads() {
      const { leadList } = this.$store.state.lead;
      if (leadList && leadList.list.length) {
        return leadList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
    regions() {
      const { regionList } = this.$store.state.region;
      if (regionList && regionList.total_items === 0) return [];

      if (regionList && regionList.list.length > 0) {
        const data = regionList.list.map(item => ({
          id: item.id,
          name: item.city,
        }));
        return data;
      }
      return null;
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
      'checkAdmin',
      'getLeadList',
      'getRegionList',
      'clearRegionList',
    ]),
    exportCSV() {
      LeadService.download(this.pagination)
        .then(response => downloadCsvFile(response))
        .catch(error =>
          this.activeAlert({
            message: error.message,
            theme: 'danger',
          })
        );
    },
    getList() {
      this.getLeadList(this.pagination);
    },
    getRegion(name) {
      const params = {
        skip: 0,
        take: 10,
        search: name,
        state: this.pagination.state,
        withCount: null,
      };

      if (name !== '') this.getRegionList(params);
      else this.clearRegionList();
    },
    onInput(name) {
      this.getRegion(name);
    },
    setRegion(region) {
      this.pagination.page = 1;
      this.pagination.skip = 0;

      if (region) this.pagination.region = region.name;
      else {
        this.clearRegionList();
        this.pagination.region = null;
      }
    },
    recoverPaginationLead() {
      const paginate = localStorage.getItem('current_pagination');
      if (paginate) {
        const data = JSON.parse(paginate);
        const dateFrom = data.date_from && new Date(data.date_from);
        const dateTo = data.date_to && new Date(data.date_to);
        this.pagination = {
          ...data,
          date_from: dateFrom,
          date_to: dateTo,
        };
      } else {
        this.getList();
      }
    },
    onChangeState(value) {
      this.pagination.state = value;
      this.pagination.skip = 0;
      this.pagination.page = 1;
      this.getRegion(this.$refs.autocomplete.$refs.input.value);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination_lead_list', pagination => {
      const paramsPage = parseInt(this.$route.params.page, 10);
      this.saveCurrentPage(pagination);
      if (paramsPage !== pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
    this.checkAdmin();
    this.clearRegionList();
  },
  beforeMount() {
    this.recoverPaginationLead();
  },
  destroyed() {
    Events.$off('update:pagination_lead_list');
  },
};
</script>

<style lang="scss" scoped>
.vdp-datepicker input {
  height: 38px;
}
</style>
